import { useRef } from 'react'

export function useFavicon() {
  const faviconAdded = useRef(false)
  if (!faviconAdded.current) {
    faviconAdded.current = true
    const existingFavicons = document.head.querySelectorAll('link[rel="icon"]')
    if (existingFavicons.length > 0) {
      return
    }
    const link = document.createElement('link')
    link.rel = 'shortcut icon'
    link.href = getFavicon()
    document.head.appendChild(link)
  }
}

export const getFavicon = () => {
  let filename = 'SevenRoomsLogo'
  if (window.location.hostname.includes('qa.')) {
    filename = 'QASevenRoomsLogo'
  }
  if (window.location.hostname.includes('demo.')) {
    filename = 'DemoSevenRoomsLogo'
  }
  return `/icons/${filename}.svg`
}
